import { render, staticRenderFns } from "./information.vue?vue&type=template&id=33c52942&scoped=true"
import script from "./information.vue?vue&type=script&lang=js"
export * from "./information.vue?vue&type=script&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=33c52942&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c52942",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33c52942')) {
      api.createRecord('33c52942', component.options)
    } else {
      api.reload('33c52942', component.options)
    }
    module.hot.accept("./information.vue?vue&type=template&id=33c52942&scoped=true", function () {
      api.rerender('33c52942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contract/customerManage/contractFrom/information.vue"
export default component.exports